/**
 * disclaimer.ts — the wording next to any figure that did not come from a laser measure.
 *
 * The text is the `disclaimer` configurator's default (packages/config), not a string in this
 * app: when Jacky settles the wording under G-AIW-1 it changes in the bb.config document and
 * here on the next build.
 *
 * Imported by PACKAGE NAME, not by relative path. The relative form resolved locally through
 * workspace hoisting but broke the container build: `pnpm install --filter @aiw/web...` does not
 * install a package the app never declared, so Rollup could not resolve `zod` from inside
 * packages/config and the image build failed with "Rollup failed to resolve import zod".
 */
import { Disclaimer } from "@aiw/config";

export const INDICATIVE_ESTIMATE = Disclaimer.defaults.indicative_estimate;
export const NO_LASER_MEASURE = Disclaimer.defaults.no_laser_measure;
export const DISCLAIMER_VERSION = Disclaimer.version;

/** The conditions under every "Supplied & installed from" price (colour page, Price my floor).
 *  PENDING Jacky's final wording (8 Oct 2026 draft). It is a constant here, not a `disclaimer`
 *  config field, because that kind has no slot for it yet; move it there when the wording settles. */
export const PRICE_MY_FLOOR_CONDITIONS =
  "Flooring supply and standard installation on a sound, level subfloor. Final price confirmed at a free onsite measure; depends on site and subfloor condition. Excludes removal of existing floor, levelling, skirting, scotia, stairs and furniture moving.";

/** The conditions under every "Supply from" price — engineered timber, whose installation is priced
 *  separately per method (Jacky, 10 Oct 2026: "for engineer timber, different installation is priced
 *  separately"). PENDING Jacky's final wording (10 Oct 2026 draft); same reason as above for living here.
 *  This file is the ONE place in apps/web/src allowed to say the words (price-my-floor.test.ts guards it). */
export const PRICE_MY_FLOOR_SUPPLY_CONDITIONS =
  "Flooring supply only; installation is priced separately and the method depends on the floor and the subfloor. Final price confirmed at a free onsite measure. Excludes removal of existing floor, levelling, skirting, scotia, stairs and furniture moving.";

/** What a product that is not on the Price my floor list says instead of a price. */
export const AVAILABLE_UPON_REQUEST = "Available upon request";
